document.addEventListener("DOMContentLoaded", function() {
	const tabs = document.querySelectorAll('.tabs__wrapper')
	tabs.forEach((tab) => {
		const tabLinks = tab.querySelectorAll(".tab-links a");
		const tabContent = tab.querySelectorAll(".tab-content .tab");
		
		tabLinks.forEach(function(el) {
			el.addEventListener("click", function(e) {
				e.preventDefault();
				const tabId = this.getAttribute("href").substr(1);
	
				tabLinks.forEach(function(el) {
					el.parentElement.classList.remove("active");
				});
				this.parentElement.classList.add("active");
	
				tabContent.forEach(function(el) {
					el.classList.remove("active");
				});
				document.getElementById(tabId).classList.add("active");
			});
		});
	})
});